import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import css_self from "../Navigation/css/NavBar.module.scss";
import css_link from "../Common/css/Link.module.scss";
import EventBus from "../../util/EventBus";
import {Black, Grey17, Grey6} from "../../theme/styles";
import React from "react";
import {DeleteForever, Download, FileUpload, Info, MoreVert, Refresh} from "@mui/icons-material";
import {IconButton, Menu, MenuItem, Tooltip, Typography} from "@mui/material";
import AttachmentUpload from "../Common/AttachmentUpload";
import ProjectPlanPhaseAttachmentFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseAttachmentFormApplet";
import {hasPrivilege} from "../../util/SessionContext";

class ProjectPlanPhaseAttachmentTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("project-plan-phase-attachment-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("project-plan-phase-attachment-applet-done", this.onDoneHandler);
    };

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("project-plan-phase-attachment-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("project-plan-phase-attachment-applet-done", this.onDoneHandler);
    };

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        }
        if (name === "Hyperlink Cell") {
            return this.renderHyperlinkCell;
        }

        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "Upload Attachment(s)") {
            this.setState({renderTarget: "Upload Attachment(s)"});
        }
        super.handleMenuClick(identifier);
    }

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    onDoneHandler = () => {
        this.applet.getEnterpriseComponent().invalidate();

        this.setState({renderTarget: null});
    };

    renderHyperlinkCell = (___, params, __, _) => {
        let buffer;
        let color;

        if (this.state.fetchBackgroundOperation) {
            color = "#7B8291"
            buffer = this.state.previousBuffer
        } else {
            color = Black
            buffer = this.state.buffer
        }

        if (params.row.id > buffer.length - 1) return;

        let content = "--";
        if (buffer[params.row.id].get(params.field) !== undefined) {
            content = buffer[params.row.id].get(params.field)
        }
        return (
            <div>
                {hasPrivilege("DOWNLOAD_PHASE_ATTACHMENT") ? (
                    <div style={{whiteSpace: "nowrap", width: "100%", display: "block", fontSize: 14, color: color, height: "100%", overflow: "hidden", textOverflow: "ellipsis"}}><a className={css_link.link} style={{color: color}} href={process.env.REACT_APP_REST_API_URL + "/t3/v1/downloads?USID=" + buffer[params.row.id].get("USID") + "&X-Enlil-AccessToken=" + this.props.appContext.sessionContext.getAccessToken()} target="_blank" rel="noreferrer">{content}</a></div>
                ) : (
                    <div style={{whiteSpace: "nowrap", width: "100%", display: "block", fontSize: 14, color: color, height: "100%", overflow: "hidden", textOverflow: "ellipsis"}}>{content}</div>
                )}
            </div>
        );
    };

    renderExtension() {
        if (this.state.renderTarget === "Upload Attachment(s)") {
            return <AttachmentUpload enterpriseComponent={this.applet.getEnterpriseComponent()}/>;
        }
        if (this.state.renderTarget === "Delete Attachment") {
            return <ProjectPlanPhaseAttachmentFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete" />;
        }
        if (this.state.renderTarget === "Download Attachment") {
        }
    };

    deriveUploadAttachmentTooltip() {
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE") {
            return "This feature is not available because the status of the phase is 'DONE'"
        }
        if (hasPrivilege("ADD_PHASE_ATTACHMENT") === false) {
            return "This feature is disabled because you do not have the 'Add Phase Attachment' privilege in any of your assigned roles."
        }
    }

    deriveDeleteAttachmentTooltip() {
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE") {
            return "This feature is not available because the status of the phase is 'DONE'"
        }
        if (hasPrivilege("DELETE_PHASE_ATTACHMENT") === false) {
            return "This feature is disabled because you do not have the 'Delete Phase Attachment' privilege in any of your assigned roles."
        }
    }

    deriveDownloadAttachmentTooltip() {
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE") {
            return "This feature is not available because the status of the phase is 'DONE'"
        }
        if (hasPrivilege("DOWNLOAD_PHASE_ATTACHMENT") === false) {
            return "This feature is disabled because you do not have the 'Download Phase Attachment' privilege in any of your assigned roles."
        }
    }

    renderMenuContent() {
        let menuItems = [];

        menuItems.push(
            <MenuItem key={"menuItem1"} onClick={(e) => {
                if (hasPrivilege("ADD_PHASE_ATTACHMENT") && this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== "DONE") {
                    e.stopPropagation();
                    this.handleMenuClick("Upload Attachment(s)");
                    this.setState({showMenu: false});
                }
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <FileUpload sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Upload Attachment
                {!hasPrivilege("ADD_PHASE_ATTACHMENT") || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE" ? (
                    <div style={{marginLeft: "10px", marginTop: "6px"}}>
                        <Tooltip title={this.deriveUploadAttachmentTooltip()}>
                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                        </Tooltip>
                    </div>
                ) : null}
            </MenuItem>
        );
        menuItems.push(
            <MenuItem key={"menuItem2"} onClick={(e) => {
                e.stopPropagation();
                this.handleMenuClick("Refresh");
                this.setState({showMenu: false});
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <Refresh sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Refresh
            </MenuItem>
        );

        return menuItems;
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-10px"}}>
                <IconButton className={css_buttons.tableOptionButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        if (hasPrivilege("DELETE_PHASE_ATTACHMENT") &&
                            this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== "DONE") {
                            this.setState({tableActionMenuTarget: null, renderTarget: "Delete Attachment"});
                        }
                    }}>
                        <DeleteForever style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Delete Attachment</Typography>
                        {!hasPrivilege("DELETE_PHASE_ATTACHMENT") ||
                        this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE" ? (
                            <div style={{marginTop: "6px", marginLeft: "5px"}}>
                                <Tooltip title={this.deriveDeleteAttachmentTooltip()}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        if (hasPrivilege("DOWNLOAD_PHASE_ATTACHMENT") &&
                            this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== "DONE") {
                            this.setState({tableActionMenuTarget: null, renderTarget: "Download Attachment"});
                        }
                    }}>
                        <Download style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}><a className={css_link.link} href={process.env.REACT_APP_REST_API_URL + "/t3/v1/downloads?USID=" + this.applet.getEnterpriseComponent().getAttributeValue("USID") + "&X-Enlil-AccessToken=" + this.props.appContext.sessionContext.getAccessToken()} target="_blank" rel="noreferrer">Download Attachment</a></Typography>
                        {!hasPrivilege("DOWNLOAD_PHASE_ATTACHMENT") ||
                        this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE" ? (
                            <div style={{marginTop: "6px"}}>
                                <Tooltip title={this.deriveDownloadAttachmentTooltip()}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                </Menu>
            </div>
        );
    };

}

export default withNavigate(withAppContext(withBreakpoint(ProjectPlanPhaseAttachmentTable)));